module.exports = __webpack_public_path__ + "img/114.71e71bdf.jpg";